import React, { useMemo, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import Images from "../../assests/Images";
import { customerData } from "../globalApi/Api";
import { useMutation, useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import PopupModel from "../popupmodel/PopupModel";

import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
const ViewCustomer = () => {
  const [searchTerm, setSearchTerm] = useState("");
  let role = sessionStorage.getItem("rolebase");

  const navigate = useNavigate();

  const {
    control,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [selectedRows, setSelectedRows] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const [popupType, setPopupType] = useState({
    type: "",
    data: "",
  });

  const handleClosePopup = () => {
    setIsPopupOpen(false);
    setPopupType({
      type: "",
      data: "",
    });
  };

  // GET API START
  const { data, isLoading, isError, refetch } = useQuery(
    "customerData",
    customerData,
    {
      refetchOnWindowFocus: false,
    }
  );

  let details = (data && data?.data) || [];

  // Filter By search
  const filteredDetails = details?.filter((item) => {
    const nameMatch =
      item?.customerName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item?.ownerName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item?.state?.toLowerCase().includes(searchTerm.toLowerCase());
    const companyMatch = String(item?.companyName)
      .toLowerCase()
      .includes(searchTerm.toLowerCase());

    const routeMatch = !watch("route") || item?.lineRoute === watch("route");
    const levelMatch =
      !watch("level") || item?.customerLevel === watch("level");
    const statusMatch = !watch("status") || item?.status === watch("status");

    return (
      (nameMatch || companyMatch) && routeMatch && levelMatch && statusMatch
    );
  });

  // Dashboard Report
  let overallCustomers = filteredDetails && filteredDetails?.length;
  const activeCount =
    filteredDetails &&
    filteredDetails?.filter((item) => item?.status?.toLowerCase() === "active")
      .length;
  const inactiveCount =
    filteredDetails &&
    filteredDetails?.filter(
      (item) => item?.status?.toLowerCase() === "inactive"
    ).length;

  // DELETE API
  // Delete a user by ID
  const deleteUser = async (id) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_HOST}/customersadd/${id}`
      );
      return response.data;
    } catch (error) {
      console.error(`Error deleting user with ID ${id}:`, error);
      throw error;
    }
  };

  const deleteUsers = async (ids) => {
    try {
      const results = await Promise.all(
        ids?.map(async (id) => {
          return await deleteUser(id);
        })
      );
      return results; // Return all results after deletion
    } catch (error) {
      console.error("Error deleting multiple users:", error.message);
      throw new Error("Failed to delete multiple users");
    }
  };
  // Mutation to delete users
  const { mutate, isLoading: deleteLoading } = useMutation({
    mutationFn: deleteUsers,
    onSuccess: () => {
      setPopupType({
        type: "delete success",
      });
      setSelectedRows([]);
      refetch();
    },
    onError: (error) => {
      console.error("Error deleting rows:", error);
      alert("Error deleting rows");
    },
  });

  // Handle checkbox change
  const handleCheckboxChange = (id) => {
    setSelectedRows((prevSelectedRows) => {
      const isSelected = prevSelectedRows?.includes(id);
      if (isSelected) {
        return prevSelectedRows?.filter((rowId) => rowId !== id);
      } else {
        return [...prevSelectedRows, id];
      }
    });
  };
  // Handle delete button click
  const handleDelete = () => {
    if (selectedRows?.length === 0) {
      alert("No rows selected");
      return;
    }
    mutate(selectedRows);
  };

  // DELETE API END

  // Download Excel
  const downloadExcel = () => {
    // Define headers
    const headers = [
      "S.NO",
      "CUSTOMER NAME",
      "COMPANY NAME",
      "ADDRESS",
      "STATE",
      "PINCODE",
      "CONTACT",
      "GST NUMBER",
      "CUSTOMER LEVEL",
      "LINE ROUTE",
      "STATUS",
    ];

    // Map data to match the headers order
    const formattedData =
      filteredDetails &&
      filteredDetails?.map((item, index) => ({
        "S.NO": index + 1,
        "CUSTOMER NAME": item?.customerName || "",
        "COMPANY NAME": item?.companyName || "",
        ADDRESS: item?.customerAddress || "",
        STATE: item?.state || "",
        PINCODE: item?.pincode || "",
        CONTACT: item?.contact || "",
        "GST NUMBER": item?.gstNumber || "",
        LEVEL: item?.customerLevel || "",
        "LINE ROUTE": item?.lineRoute || "",
        STATUS: item?.status || "",
      }));

    // Create a new workbook and a worksheet
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(formattedData, { header: headers });

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Generate Excel file and trigger download
    XLSX.writeFile(wb, "View Customers.xlsx");
  };

  const routeNames = useMemo(() => {
    return [
      ...new Set(
        (filteredDetails || [])
          .map((item) => item?.lineRoute?.trim())
          .filter(Boolean) // Removes undefined, null, empty strings
      ),
    ];
  }, [filteredDetails]);

  return (
    <>
      <div className="view_form_block">
        <div className="view_form_sub_block">
          {/* DASHBOARD */}
          <div className="row my-3 d-flex justify-content-center">
            <div className="col-12 col-sm-6 col-md-4 col-lg-2 dashborad-card-block --first-block">
              <span className="dashboard-heading" style={{ color: "#6B7280" }}>
                Overall
              </span>
              <span className="dashboard-value" style={{ color: "#111827" }}>
                {overallCustomers || 0}
              </span>
            </div>
            <div className="col-12 col-sm-6 col-md-4 col-lg-2 dashborad-card-block">
              <span className="dashboard-heading" style={{ color: "#059669" }}>
                Active
              </span>
              <span className="dashboard-value" style={{ color: "#059669" }}>
                {activeCount || 0}
              </span>
            </div>
            <div className="col-12 col-sm-6 col-md-4 col-lg-2 dashborad-card-block --last-block">
              <span className="dashboard-heading" style={{ color: "#DC2626" }}>
                Inactive
              </span>
              <span className="dashboard-value" style={{ color: "#DC2626" }}>
                {inactiveCount || 0}
              </span>
            </div>
          </div>
          {/* Filter and Search */}
          <div className="row px-1 d-flex justify-content-between align-items-center">
            <div className="col-12 col-md-3">
              <input
                type="search"
                className="view_table_search"
                placeholder="Search by customer Name,owner Name,state"
                title="Search by customer Name,owner Name,state"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="col-12 col-md-9 d-flex align-items-center gap-2">
              {/* <Controller
                name="route"
                control={control}
                render={({ field }) => (
                  <select {...field} className="view-table-status">
                    <option value="">ALL ROUTE</option>
                    <option value="Route-I">Route-I</option>
                    <option value="Route-II">Route-II</option>
                    <option value="Route-III">Route-III</option>
                  </select>
                )}
              /> */}
              <Controller
                name="route"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <select {...field} className="view-table-status">
                    <option value="">ALL ROUTE</option>
                    {routeNames?.map((route) => (
                      <option key={route} value={route}>
                        {route}
                      </option>
                    ))}
                  </select>
                )}
              />

              <Controller
                name="level"
                control={control}
                render={({ field }) => (
                  <select {...field} className="view-table-status">
                    <option value="">ALL LEVEL</option>
                    <option value="High Level">High Level</option>
                    <option value="Mid Level">Mid Level</option>
                    <option value="Low Level">Low Level</option>
                  </select>
                )}
              />
              {/* Status Filter */}
              <Controller
                name="status"
                control={control}
                render={({ field }) => (
                  <select {...field} className="view-table-status">
                    <option value="">STATUS</option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                )}
              />

              {/* Download Button */}
              <div
                className="download_btn_block d-flex align-items-center"
                onClick={() => {
                  downloadExcel();
                }}
              >
                <div className="download_image_block">
                  <img
                    src={Images?.downloadIcon}
                    className="image_icon"
                    alt="no-image"
                  />
                </div>
                <button className="download_btn">DOWNLOAD</button>
              </div>

              {/* Delete Button */}
              {selectedRows?.length !== 0 ? (
                <>
                  <div
                    className="download_btn_block d-flex align-items-center"
                    onClick={() => {
                      setPopupType({
                        type: "confirm delete",
                      });
                      setIsPopupOpen(true);
                    }}
                  >
                    <div className="download_image_block">
                      <img
                        src={Images?.deleteIcon}
                        className="image_icon"
                        alt="no-image"
                      />
                    </div>
                    <button className="download_btn">DELETE</button>
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="row px-3 my-3">
            <div className="col-lg-12 view_table_section">
              <div className="table-responsive view_table_block">
                <table className="table">
                  <thead>
                    <tr>
                      <th className="view-table-heading">SELECT</th>
                      <th className="view-table-heading">CUSTOMER ID</th>
                      <th className="view-table-heading">CUSTOMER NAME</th>
                      <th className="view-table-heading">COMPANY NAME</th>
                      <th className="view-table-heading">LEVEL</th>
                      <th className="view-table-heading">LINE ROUTE</th>
                      <th className="view-table-heading">ROUTE NAME</th>
                      <th className="view-table-heading">ADDRESS</th>
                      <th className="view-table-heading">STATE</th>
                      <th className="view-table-heading">STATUS</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading ? (
                      <>
                        <h5 className="my-3">L O A D I N G . . .</h5>
                      </>
                    ) : filteredDetails?.length > 0 ? (
                      <>
                        {filteredDetails?.map((data, i) => {
                          return (
                            <>
                              <tr
                                key={i}
                                onClick={() => {
                                  if (role !== "Sales") {
                                    navigate("/newCustomer", { state: data });
                                  }
                                }}
                                style={{
                                  cursor:
                                    role !== "Sales" ? "pointer" : "default",
                                }}
                              >
                                <td
                                  className="view-table-data"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                  }}
                                >
                                  <input
                                    type="checkbox"
                                    style={{
                                      accentColor: "blue",
                                      width: "18px",
                                      height: "18px",
                                      cursor: "pointer",
                                    }}
                                    checked={selectedRows?.includes(data?.id)}
                                    onChange={() =>
                                      handleCheckboxChange(data?.id)
                                    }
                                  />
                                </td>
                                <td className="view-table-data">
                                  {data?.id || "-"}
                                </td>
                                <td className="view-table-data">
                                  {data?.customerName || "-"}
                                </td>
                                <td className="view-table-data">
                                  {data?.companyName || "-"}
                                </td>
                                <td className="view-table-data">
                                  {data?.customerLevel || "-"}
                                </td>
                                <td className="view-table-data">
                                  {data?.lineRoute || "-"}
                                </td>
                                <td className="view-table-data">
                                  {data?.routeName || "-"}
                                </td>
                                <td className="view-table-data">
                                  {data?.customerAddress || "-"}
                                </td>
                                <td className="view-table-data">
                                  {data?.state || "-"}
                                </td>
                                <td className="view-table-data">
                                  {data?.status || "-"}
                                </td>
                              </tr>
                            </>
                          );
                        })}
                      </>
                    ) : (
                      <>
                        <h6>No Record Founds</h6>
                      </>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <PopupModel
        isOpen={isPopupOpen}
        closePopup={handleClosePopup}
        popupType={popupType}
        handleDelete={handleDelete}
        deleteLoading={deleteLoading}
        message="Are you sure you want to delete the customer details?"
        setPopupType={setPopupType}
      />
    </>
  );
};

export default ViewCustomer;
